import { getAugmentedNamespace as e } from "./index135.mjs";
import * as r from "./index553.mjs";
const m = /* @__PURE__ */ e(r);
export {
  m as default
};
